module.exports = __webpack_public_path__ + "assets/img/img89.87537aaf.png";